import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { CountryInfoResponse } from '@/main/models/response/countryInfoResponse';

export abstract class ICountryInfoApi {

  abstract getCountryInfo(
    guidCountry: string
  ): Promise<AxiosResponse<Result<CountryInfoResponse>>>;
}

